module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"病気":"病気","食事":"食事","休息":"休息","運動":"運動","メンタルヘルス":"メンタルヘルス","飲酒・喫煙":"飲酒・喫煙","その他":"その他","ウェルビーイング":"ウェルビーイング"},"en":{"病気":"Disease","食事":"Meals","休息":"Rest","運動":"Exercise","メンタルヘルス":"Mental health","飲酒・喫煙":"Drinking and Smoking","その他":"Other","ウェルビーイング":"Wellbeing"}}')
  delete Component.options._Ctor
}
